import { render, staticRenderFns } from "./AddressInfoComponent.vue?vue&type=template&id=158da490&scoped=true&"
import script from "./AddressInfoComponent.vue?vue&type=script&lang=js&"
export * from "./AddressInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddressInfoComponent.vue?vue&type=style&index=0&id=158da490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158da490",
  null
  
)

export default component.exports